const selectedStates = new Set();
const selectedLocationTypes = new Set();

window.addEventListener('DOMContentLoaded', () => {
    const resetButton = document.querySelector('.locations__reset-button');
    const selectedFiltersContainer = document.querySelector('.locations-filter__selected-filters');

    if (!resetButton || !selectedFiltersContainer) return;

    updateUI();

    document.querySelectorAll('.locations input[type="checkbox"]').forEach((input) => {
        input.checked = false;
    });

    selectedStates.clear();
    selectedLocationTypes.clear();
    selectedFiltersContainer.innerHTML = '';
    toggleResetButton();

    function toggleResetButton() {
        const total = selectedStates.size + selectedLocationTypes.size;

        if (total > 0) {
            resetButton.classList.add('locations__reset-button--visible');
        } else {
            resetButton.classList.remove('locations__reset-button--visible');
        }

        if (total === 0) {
            document.querySelectorAll('.locations__area').forEach((area) => area.classList.add('open'));
            document.querySelectorAll('.locations__type').forEach((typeEl) => {
                typeEl.style.display = 'block';
            });
        }
    }

    function updateUI() {
        document.querySelectorAll('.locations').forEach((el) => {
            const stateTrigger = el.querySelector('.locations__dropdown-label--state');
            const stateChoices = el.querySelectorAll('.locations__dropdown-choice--state');
            const stateCountWrapper = el.querySelector('.locations__dropdown-count--state');

            const typeTrigger = el.querySelector('.locations__dropdown-label--locationtyp');
            const typeChoices = el.querySelectorAll('.locations__dropdown-choice--locationtyp');
            const typeCountWrapper = el.querySelector('.locations__dropdown-count--locationtyp');
            const allLocationTypes = el.querySelectorAll('.locations__type');

            updateStateUI(stateTrigger, stateChoices, stateCountWrapper);
            updateLocationTypeUI(typeTrigger, typeChoices, typeCountWrapper, allLocationTypes);
            filterVisibleAreas();
        });
    }

    function updateStateUI(stateTrigger, stateChoices, stateCountWrapper) {
        const labelSpan = stateTrigger?.querySelector('span');

        if (selectedStates.size === 1) {
            const selectedValue = [...selectedStates][0];
            const selectedChoice = [...stateChoices].find((c) => c.querySelector('input').value === selectedValue);
            labelSpan.innerText = selectedChoice?.querySelector('span')?.innerText || 'Bitte wählen';
        } else if (selectedStates.size > 1) {
            labelSpan.innerText = 'Mehrere gewählt';
        } else {
            labelSpan.innerText = 'Bitte wählen';
        }

        stateCountWrapper.innerHTML = '';
        if (selectedStates.size > 0) {
            const countSpan = document.createElement('span');
            countSpan.innerText = selectedStates.size;
            countSpan.classList.add('state-count');
            stateCountWrapper.appendChild(countSpan);
        }
    }

    function updateLocationTypeUI(typeTrigger, typeChoices, typeCountWrapper, allLocationTypes) {
        const span = typeTrigger?.querySelector('span');

        if (selectedLocationTypes.size === 1) {
            const val = [...selectedLocationTypes][0];
            const selected = [...typeChoices].find((c) => c.querySelector('input').value === val);
            span.innerText = selected?.querySelector('span')?.innerText || 'Bitte wählen';
        } else if (selectedLocationTypes.size > 1) {
            span.innerText = 'Mehrere gewählt';
        } else {
            span.innerText = 'Bitte wählen';
        }

        typeCountWrapper.innerHTML = '';
        if (selectedLocationTypes.size > 0) {
            const countSpan = document.createElement('span');
            countSpan.innerText = selectedLocationTypes.size;
            countSpan.classList.add('type-count');
            typeCountWrapper.appendChild(countSpan);
        }
    }

    document.addEventListener('click', (event) => {
        document.querySelectorAll('.locations__dropdown').forEach((dropdown) => {
            if (!dropdown.contains(event.target)) {
                dropdown.classList.remove('open');
            }
        });
    });

    document.querySelectorAll('.locations').forEach((el) => {
        const stateTrigger = el.querySelector('.locations__dropdown-label--state');
        const stateChoices = el.querySelectorAll('.locations__dropdown-choice--state');
        const stateDropdown = stateTrigger?.closest('.locations__dropdown');
        const stateCountWrapper = el.querySelector('.locations__dropdown-count--state');
        const areas = el.querySelectorAll('.locations__area');

        const typeTrigger = el.querySelector('.locations__dropdown-label--locationtyp');
        const typeChoices = el.querySelectorAll('.locations__dropdown-choice--locationtyp');
        const typeDropdown = typeTrigger?.closest('.locations__dropdown');
        const typeCountWrapper = el.querySelector('.locations__dropdown-count--locationtyp');
        const allLocationTypes = el.querySelectorAll('.locations__type');

        stateDropdown?.addEventListener('click', (e) => e.stopPropagation());
        stateTrigger?.addEventListener('click', () => {
            stateDropdown?.classList.toggle('open');

            //focus on the dropdown
            if (window.innerWidth < 768) {
                stateDropdown.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });

        typeDropdown?.addEventListener('click', (e) => e.stopPropagation());
        typeTrigger?.addEventListener('click', () => {
            typeDropdown?.classList.toggle('open');

            //focus on the dropdown
            if (window.innerWidth < 768) {
                typeDropdown.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        });

        stateChoices.forEach((choice) => {
            const input = choice.querySelector('input');
            const value = input.value;
            const label = choice.querySelector('span').innerText;

            choice.addEventListener('change', (e) => {
                if (input.checked) {
                    selectedStates.add(value);
                    addFilter(value, label, 'state');
                } else {
                    selectedStates.delete(value);
                    removeFilter(value);
                }

                updateStateUI(stateTrigger, stateChoices, stateCountWrapper);
                toggleResetButton();
                filterVisibleAreas();
            });
        });

        typeChoices.forEach((choice) => {
            const input = choice.querySelector('input');
            const value = input.value;
            const label = choice.querySelector('span').innerText;

            choice.addEventListener('change', () => {
                if (input.checked) {
                    selectedLocationTypes.add(value);
                    addFilter(value, label, 'locationtyp');
                } else {
                    selectedLocationTypes.delete(value);
                    removeFilter(value);
                }

                updateLocationTypeUI(typeTrigger, typeChoices, typeCountWrapper, allLocationTypes);
                toggleResetButton();
                filterVisibleAreas();
            });
        });

        function addFilter(value, label, type) {
            if (selectedFiltersContainer.querySelector(`[data-value="${value}"]`)) return;

            const div = document.createElement('div');
            div.classList.add('locations-filter__item');
            div.setAttribute('data-value', value);
            div.setAttribute('data-type', type);
            div.innerHTML = `
                <span class="locations-filter__item-titel">${label}</span>
                <button class="locations__item-close" aria-label="Filter löschen"></button>
            `;

            div.querySelector('.locations__item-close').addEventListener('click', () => {
                const isState = type === 'state';
                const set = isState ? selectedStates : selectedLocationTypes;
                const dropdownChoices = isState ? stateChoices : typeChoices;

                set.delete(value);

                dropdownChoices.forEach((choice) => {
                    const input = choice.querySelector('input');
                    if (input.value === value) input.checked = false;
                });

                div.remove();

                if (isState) {
                    updateStateUI(stateTrigger, stateChoices, stateCountWrapper);
                } else {
                    updateLocationTypeUI(typeTrigger, typeChoices, typeCountWrapper, allLocationTypes);
                }

                toggleResetButton();
                filterVisibleAreas();
            });

            selectedFiltersContainer.appendChild(div);
        }

        function removeFilter(value) {
            const el = selectedFiltersContainer.querySelector(`[data-value="${value}"]`);
            if (el) el.remove();
        }

        resetButton?.addEventListener('click', () => {
            selectedStates.clear();
            selectedLocationTypes.clear();
            selectedFiltersContainer.innerHTML = '';
            document.querySelectorAll('.locations input[type="checkbox"]').forEach((input) => (input.checked = false));
            toggleResetButton();
            updateUI();
            filterVisibleAreas();
        });
    });
});

function filterVisibleAreas() {
    const areas = document.querySelectorAll('.locations__area');

    areas.forEach((area) => {
        const areaState = area.getAttribute('data-state');
        const types = area.querySelectorAll('.locations__type');

        let showArea = false;

        types.forEach((typeEl) => {
            const type = typeEl.getAttribute('data-location-type');
            const matchesType = selectedLocationTypes.size === 0 || selectedLocationTypes.has(type);
            const matchesState = selectedStates.size === 0 || selectedStates.has(areaState);

            const showThis = matchesType && matchesState;
            typeEl.style.display = showThis ? 'block' : 'none';

            if (showThis) {
                showArea = true;
            }
        });

        area.style.display = showArea ? 'block' : 'none';
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const locationAreaEls = document.querySelectorAll('.locations__area');
    if (!locationAreaEls.length) return;

    let isDesktopBefore = window.matchMedia('(min-width: 768px)').matches;

    function handleLocationAreas() {
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;

        if (isDesktop || isDesktop !== isDesktopBefore) {
            locationAreaEls.forEach((area) => {
                area.open = isDesktop;
            });
        }

        isDesktopBefore = isDesktop;
    }

    handleLocationAreas();

    window.addEventListener('resize', handleLocationAreas);
});

document.addEventListener('DOMContentLoaded', function () {
    const infoButtons = document.querySelectorAll('.locations__type-info');

    if (!infoButtons.length) return;

    infoButtons.forEach((button) => {
        button.addEventListener('click', function () {
            const targetSelector = this.dataset.target;
            const modal = document.querySelector(targetSelector);

            if (!modal) return;

            modal.classList.add('is-active');
            document.body.classList.add('no-scroll');
        });
    });

    const closeButtons = document.querySelectorAll('.locations__modal-close');

    closeButtons.forEach((closeBtn) => {
        closeBtn.addEventListener('click', function () {
            const modal = this.closest('.locations__modal');
            if (!modal) return;

            modal.classList.remove('is-active');
            document.body.classList.remove('no-scroll');
        });
    });

    let isDesktopBefore = window.matchMedia('(min-width: 768px)').matches;
    ['resize', 'keydown'].forEach((eventType) => {
        window.addEventListener(eventType, (event) => {
            const isDesktop = window.matchMedia('(min-width: 768px)').matches;
            if ((eventType === 'resize' && isDesktop !== isDesktopBefore) || event.key === 'Escape') {
                const modals = document.querySelectorAll('.locations__modal');
                modals.forEach((modal) => {
                    modal.classList.remove('is-active');
                });
                document.body.classList.remove('no-scroll');
            }
            isDesktopBefore = isDesktop;
        });
    });
});
